import * as React from 'react';
import './CodeInput.scss';
import { Alert } from '@material-ui/lab';
import { Collapse, IconButton } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
// onChange only outputs a string if the code is complete, else returns null
interface ICodeInputProps {
  value: string;
  onChange?(value: string): void;
  reHandleSubmitForgot: void;
  invalid?: boolean;
  success?: boolean;
  disabled?: boolean;
  resend: string;
  InvalidCode: number;
  alertType: number;
}

interface ICodeInputState {
  currentInput: number;
  code: string;
  values: string[];
  alertBox: boolean;
}

export class CodeInput extends React.Component<any, ICodeInputState> {
  public state: ICodeInputState = {
    currentInput: 0,
    code: '',
    values: ['', '', '', ''],
    alertBox: true
  };

  private inputs: any = [null, null, null, null];

  private handleInputChange = (index: number, value: string) => {
    const values = this.state.values;
    values[index] = value;
    const code = values.join('');
    const isComplete = code.length === 4;
    this.setState(
      {
        code,
        values
      },
      () => {
        if (this.props.onChange) {
          if (isComplete) {
            this.props.onChange(code);
          } else {
            this.props.onChange(null);
          }
        }
      }
    );
  };

  private handleInputSelect = (index: number) => {
    if (this.inputs[index]) {
      this.inputs[index].select();
    }
    this.setState({ currentInput: index });
  };

  private handleKeyup = () => {
    const ci = this.state.currentInput;
    const nextIndex = ci + 1;
    if (nextIndex > 3) {
      return;
    }
    if (this.inputs[nextIndex]) {
      this.inputs[nextIndex].focus();
    }
  };
  private ResetInputValues = () => {
    this.setState({
      values: ['', '', '', ''],
      currentInput: 0,
      code: ''
    });
    this.props.reHandleSubmitForgot();
  };

  public render() {
    const className = `rp-codeinput ${this.props.invalid ? 'invalid' : ''}`;
    const alertMessage =
      this.props.InvalidCode === this.props.alertType ? true : false;

    return (
      <>
        <div className="codeinput">
          {
            <Collapse in={alertMessage && this.state.alertBox}>
              <Alert
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() =>
                      this.setState({
                        alertBox: false
                      })
                    }
                  >
                    {/* <MatrialCloseIcon fontSize="inherit" />  */}
                  </IconButton>
                }
                severity="error"
              >
                <span className="alert-message">
                  {/* <i className="rpds-error alert-error-icon"/> */}
                  Oops! The code you have entered is either invalid or expired,
                  please click
                  <a href="javascript:void(0)" onClick={this.ResetInputValues}>
                    here
                  </a>
                  to receive a new code
                  {/* <i className="rpds-close alert-close-button"/> */}
                  {/* Oops! Your code has might invalid (or) expired, please click resend
                  code to receive a new code. */}
                </span>
              </Alert>
            </Collapse>
          }
        </div>

        <div className={className}>
          <input
            type="text"
            maxLength={1}
            onFocus={() => this.handleInputSelect(0)}
            onChange={e => this.handleInputChange(0, e.target.value)}
            value={this.state.values[0]}
            ref={e => (this.inputs[0] = e)}
            onKeyUp={this.handleKeyup}
            disabled={this.props.disabled}
          />
          <input
            type="text"
            maxLength={1}
            onFocus={() => this.handleInputSelect(1)}
            onChange={e => this.handleInputChange(1, e.target.value)}
            value={this.state.values[1]}
            ref={e => (this.inputs[1] = e)}
            onKeyUp={this.handleKeyup}
            disabled={this.props.disabled}
          />
          <input
            type="text"
            maxLength={1}
            onFocus={() => this.handleInputSelect(2)}
            onChange={e => this.handleInputChange(2, e.target.value)}
            value={this.state.values[2]}
            ref={e => (this.inputs[2] = e)}
            onKeyUp={this.handleKeyup}
            disabled={this.props.disabled}
          />
          <input
            type="text"
            maxLength={1}
            onFocus={() => this.handleInputSelect(3)}
            onChange={e => this.handleInputChange(3, e.target.value)}
            value={this.state.values[3]}
            ref={e => (this.inputs[3] = e)}
            onKeyUp={this.handleKeyup}
            disabled={this.props.disabled}
          />

          {this.props.success ? (
            <span className="rp-codeinput--success">
              <i className="rpds rpds-check-circle" />
            </span>
          ) : null}
        </div>
        <div className="text-center">
          <button
            className={`rp-forgotpassword--resend ${
              this.props.success ? 'rp-forgotpassword--resend--disabled' : ''
            }`}
            onClick={this.ResetInputValues}
            disabled={this.props.success}
          >
            Resend Code
          </button>
        </div>
      </>
    );
  }
}
